<h2 mat-dialog-title class="modal-header">
    Choissisez votre organsiation
</h2>

<mat-dialog-content>

    @if(hasOrganisation) {
    <p class="info">Sélectionnez l'organisation pour laquelle vous souhaitez créer l'évenement</p>

    <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Mes organisations</mat-label>
            <mat-select formControlName="id" required>
                @for (org of organisations; track $index) {
                <mat-option [value]="org.id">{{org.name}} </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <div class="d-flex flex-row justify-content-center p2 gap-3">
            <button matButton="filled" color="primary" type="submit">Créer l'événement</button>
            <button matButton="outlined" color="primary" type="button" [mat-dialog-close]="false">Fermer</button>
        </div>
    </form>
    } @else {
    <p>Votre compte est lié à aucune organisation. Veuillez vous rapprocher de l'organisation à laquelle vous souhaitez
        travailler</p>
    <div class="d-flex flex-row justify-content-center">
        <button matButton="outlined" color="primary" type="button" [mat-dialog-close]="false">Fermer</button>
    </div>

    }


</mat-dialog-content>